import * as React from "react";

function SvgCalendar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 21.96 23.97"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M21.99 5.14v17.12a1.67 1.67 0 01-.5 1.2 1.64 1.64 0 01-1.19.51H1.69a1.62 1.62 0 01-1.19-.51 1.67 1.67 0 01-.5-1.2V5.14a1.68 1.68 0 01.5-1.16 1.62 1.62 0 011.19-.56h1.69V2.14A2.08 2.08 0 013.99.63a2 2 0 011.5-.65h.85a2 2 0 011.49.65 2.08 2.08 0 01.62 1.51v1.28h5.07V2.14a2.08 2.08 0 01.62-1.51 2 2 0 011.49-.65h.85a2 2 0 011.51.65 2.08 2.08 0 01.62 1.51v1.28h1.69a1.64 1.64 0 011.17.56 1.68 1.68 0 01.52 1.16zm-20.3 7.27h3.8V8.56h-3.8zm0 5.14h3.8v-4.28h-3.8zm0 4.71h3.8V18.4h-3.8zM6.76 5.98V2.14a.39.39 0 00-.13-.3.37.37 0 00-.29-.13h-.85a.37.37 0 00-.29.13.39.39 0 00-.13.3v3.84a.38.38 0 00.13.3.37.37 0 00.29.13h.85a.37.37 0 00.29-.13.38.38 0 00.13-.3zm-.42 6.42h4.22V8.56H6.34zm0 5.14h4.22v-4.27H6.34zm0 4.71h4.22V18.4H6.34zm5.07-9.85h4.22V8.56h-4.22zm0 5.14h4.22v-4.27h-4.22zm0 4.71h4.22V18.4h-4.22zM16.9 5.98V2.14a.39.39 0 00-.13-.3.37.37 0 00-.29-.13h-.85a.41.41 0 00-.3.13.42.42 0 00-.12.3v3.84a.43.43 0 00.42.43h.85a.37.37 0 00.29-.13.38.38 0 00.13-.3zm-.42 6.42h3.8V8.56h-3.8zm0 5.14h3.8v-4.27h-3.8zm0 4.71h3.8V18.4h-3.8z" />
    </svg>
  );
}

const MemoSvgCalendar = React.memo(SvgCalendar);
export default MemoSvgCalendar;
